import React from 'react';

export interface MediaExtensionProps {
    imgSrc: string;
    altTag: string;
}

export const MediaExtension = ({ imgSrc, altTag }: MediaExtensionProps) => {
    const imgStyle = {
        maxWidth: '100%',
        border: '2px inset rgba(9,30,66,0.08)',
        WebkitBorderRadius: '3px',
        MozBorderRadius: '3px',
        borderRadius: '3px'
    };

    return (
        <div style={{ textAlign: 'center' }}>
            {(imgSrc || altTag) && (
                <img
                    style={imgStyle}
                    src={imgSrc}
                    alt={altTag}
                    onDragStart={(e) => {
                        e.preventDefault();
                    }}
                />
            )}
        </div>
    );
};
